import request from './http';

export function mySamples(data) {
  return request.post('html/user/userSample', data);
}

export function deleteSample(data) {
  return request.post('html/User/delUserSample', data);
}

export function create(data) {
  return request.post('html/user/addSample', data);
}

export function detail(data) {
  return request.post('html/sample/sampleDetail', data);
}

export function editDetail(data) {
  return request.post('html/user/userSampleDetail', data);
}

export function edit(data) {
  return request.post('html/user/editUserSample', data);
}
